<template>
	<main class="linha">
		<div class="container" v-if="loaded">
			<!-- <h2 v-if="loaded">{{ duvidas[0].categoriaRaw }}</h2> -->
			<!-- <h2>Dúvidas Filtradas</h2> -->
			<ul class="allDuvidas">
				<li v-for="duvida in duvidas[$route.params.categoria]" :key="duvida.id">
					<router-link :to="'/duvidas/' + $route.params.categoria + '/' + duvida.slug">{{ duvida.titulo }}</router-link>
				</li>
			</ul>
			<button @click="voltar" class="btnVoltar">Voltar para o Início</button>
		</div>
		<div class="container" v-else>
			<img src="@/assets/loading.gif" />
			<button @click="voltar" class="btnVoltar">Voltar para o Início</button>
		</div>
	</main>
</template>

<script>
export default {
	name: 'duvidas',
	data() {
		return {};
	},
	methods: {
		voltar() {
			this.$router.push('/');
		},
	},
	computed: {
		duvidas() {
			return this.$store.getters.duvidas;
		},
		loaded() {
			return this.$store.getters.duvidasLoaded;
		},
		categorias() {
			return this.$store.getters.categorias;
		},
		titulo() {
			let c = this.categorias.find((categoria) => categoria.slug === this.$route.params.categoria);
			return 'aceacae';
			return c.nome;
		},
	},
	beforeCreate() {
		this.$store.dispatch('changeHome', false);
	},
};
</script>

<style lang="scss">
@import './../assets/sass/duvidas.scss';
</style>
